Apt.fn.extend('properties', {
	/**
	 * Fetch properties
	 *
	 * @param {Object} options
	 * @param {Function} fn
	 */
	fetch(options, fn) {
		Apt.index.request({
			resource: 'listings',
			filters: Object.assign({
				limit: 36,
				sort: '-promoted'
			}, options),
			transform: this.transform
		}, fn);
	},

	/**
	 * Transform server response for client
	 *
	 * @param {Object} result
	 * @param {Number} index
	 * @param {Number} [load=4]
	 */
	transform(result, index, load = 4) {
		result.price = LS.util.formatCurrency(result.price);

		if (result.size) {
			result.size = LS.util.formatSize(result.size, true);
		}

		if (result.image) {
			result.image.path = $.get('cdnUrl') + result.image.path;
		} else {
			const center = result.context.center;

			let z = result.size && result.size > 20 ?
				14 : 15;

			result.image = {
				tile: true,
				path: `https://tiles.stadiamaps.com/data/imagery/${z}/` +
					LS.util.getTileX(center[0], z) + '/' + LS.util.getTileY(center[1], z) + '.jpg'
				// path: `https://maps.geo.us-east-1.amazonaws.com/v2/tiles/raster.satellite/${z}/` +
				// 	LS.util.getTileX(center[0], z) + '/' + LS.util.getTileY(center[1], z) + '?key=' + $.get('global.awsKey')
			};
		}

		result.image.alt = result.title;
		result.image.cover = true;
		result.image.fetched = true;
		result.image.lazy = index >= load;
		result.image.position = 1;

		result.images = [
			result.image
		];

		result.active_image = 1; // eslint-disable-line

		delete result.image;

		result.active = 'gallery';
	},

	/**
	 * Get base app model
	 *
	 * @param {Object} filters
	 * @param {Object} [loc]
	 * @param {Object} [data]
	 * @param {Boolean} [init=false]
	 */
	getModel(filters, loc, data, init) {
		const lease = filters.format === 'leases';

		let empty = 'Reset filters or search ';
		let reset = '';

		if (! loc && $.context) {
			loc = $.context('location');
		}

		if (loc && (
			filters.search ||
			filters.tag ||
			filters.type
		) && (init || (
			data.total_pages === 1 || (
				data.total_pages > 1 &&
				data.current_page === data.total_pages
			)
		))) {
			let path = lease ?
				'/leases' : '/properties';

			if (loc.slug) {
				path += '/' + loc.slug;
			}

			let message = '<a href="' + path + '" class="-plain">' +
				'land for ' + (lease ? 'lease' : 'sale') + ' in ' +
				LS.location.heading(loc, true) + '</a>';

			if (loc.slug && loc.ancestors && [
				'locality',
				'region',
				'subterritory'
			].includes(loc.type)) {
				let root = data.root;
				let territory;

				if (! root && $.context) {
					root = $.context('root');
				}

				loc.ancestors.forEach(item => {
					if (item.type === 'territory') {
						territory = item;
					}
				});

				if (root && territory) {
					message += ` and <a href="${root[1]}/${territory.slug}" class="-plain">${root[0]} in ${territory.name}</a>`;
				}
			}

			empty += message;

			reset = {
				after: ! init &&
					data.current_page === data.total_pages,
				message: message
			};
		} else {
			empty += 'nearby listings on the map';
		}

		return {
			ad: [4, 14, 22, 32, 40, 50],
			empty: data.total ?
				'' : empty + '.',
			format: lease ?
				'leases' : 'sales',
			label: 'property',
			reset: reset
		};
	},

	/**
	 * Get sorting options
	 *
	 * @returns {Object}
	 */
	getSorting() {
		return {
			'-promoted': 'For you',
			'-newest': 'Newest',
			'-price': 'Price: high to low',
			'price': 'Price: low to high',
			'-size': 'Size: large to small',
			'size': 'Size: small to large',
			'-updated': 'Updated'
		};
	}
}, {
	/**
	 * Create the property results application
	 */
	initApp() {
		const scope = this;
		const pub = scope.$public;
		const $results = $$('results');
		const app = $results.data('id');

		let exclude = [];
		let current = null;
		let events;
		let ads;

		scope.index = Apt.fn.index().init({
			app: app,
			init: false,
			paginate: true,
			path: scope.section,
			reload: true,
			resource: 'listings',
			scrollTop: false,
			sorting: pub.getSorting(),
			target: $results,
			transform: scope.$public.transform,
			value: $results.data('value'),
			view: 'properties.results',
			params: {
				limit: 50
			},
			modify: data => {
				Object.assign(data, pub.getModel(
					LS.filters.get(),
					data.location || $.context('location'),
					data,
					! events && ! $.history.pending()
				));
			},
			build: filters => {
				if (! filters.sort) {
					return;
				}

				const parsed = LS.filters.get();

				if (parsed.center) {
					filters.center = parsed.center;

					if (parsed.zoom) {
						filters.zoom = parsed.zoom;
					}
				}
			},
			translate: filters => {
				if (( LS.user.get('hidden') || []).length) {
					filters.user = LS.user.get('id');
				}

				if (LS.filters.get('buffer') !== '0') {
					filters.buffer = true;
				}
			},
			send: (xhr, conf) => {
				const data = conf.data;

				document.documentElement.scrollTop = 0;

				if (! data.center) {
					const center = LS.location.center() || LS.user.center();

					if (center) {
						data.center = center;
					}
				}

				data.attach = [
					'sources'
				];

				if (! data.page || data.page === 1 && ! data.bounds) {
					data.attach.push('render');
				}
			},
			updated: (data, init) => {
				const loc = data.location;
				const slug = loc ?
					loc.slug : (LS.filters.get('location') || null);
				const relocated = slug !== current;

				current = slug;

				if (loc) {
					loc.heading = LS.location.heading(loc);

					if (relocated) {
						$$('propertiesLocation').text(loc.heading);
					}
				}

				if (init) {
					const $sources = $$('propertiesSources');

					scope.sources = $sources.length ?
						LS.util.key($sources.data('value') || [], 'id') : {};
				} else {
					scope.updateApp(data);

					scope.filters.refresh(relocated ? loc : false);

					if (current && relocated && scope.map) {
						scope.map.removeDraw();
					}

					if (events) {
						events.update();
					}

					if (data.current_page === 1) {
						LS.util.destroy(scope, 'meta');

						$$('propertiesFooter').remove();
					}
				}

				scope.updateTracking(data.results);

				if (scope.fallback) {
					scope.fallback.$destroy();
				}

				if (data.current_page === 1) {
					exclude = [];
				}

				exclude = [
					...exclude,
					...LS.util.pluck(data.results, 'id')
				];

				if (! data.total || data.current_page === data.total_pages) {
					scope.fallbackApp(exclude);
				}

				if (ads) {
					if (! scope.sync || ! scope.sync.check(true)) {
						ads.load();
					}
				} else if (data.results.length) {
					LS.util.load('ads', () => {
						let save = true;

						ads = Apt.fn.ads().init({
							margin: () => 800,
							target: () => scope.getTarget(),
							units: () => $('[data-unit]', '$propertiesPreviews'),
							empty: ($ad) => {
								if (Math.random() > 0.5) {
									const size = $.screen.size();

									if ((size < 3 || size === 4) && ! $ad.visible()) {
										$ad.remove();

										return;
									}
								}

								LS.util.view('ads', save ? 'save' : 'agents', template => {
									$ad.html(template)
								});

								save = ! save;
							}
						});
					});
				}

				if (init || relocated) {
					scope.loadAgent(loc || $.context('location'), data.results[0]);
				}
			},
			unload: () => {
				if (events) {
					events.unload();
				}

				if (ads) {
					ads.unload();
				}
			},
			destroy: () => {
				if (events) {
					events.$destroy();

					Apt.panel.unload();
				}

				if (ads) {
					ads.$destroy();

					ads = null;
				}
			}
		}, () => {
			if (location.hash === '#inactive') {
				LS.util.flash('Inactive listing — search nearby');
			}

			let path;

			Apt['properties.panel'].init({
				map: () => scope.map,
				sync: () => scope.sync,
				opening: () => {
					path = $.routes.uri().path;
				},
				opened: () => {
					scope.path = path;
				}
			});

			events = Apt.fn['properties.events']()
				.init({
					app: app,
					delegate: '$results',
					map: () => scope.map,
					createMap: options => {
						if (! scope.map) {
							scope.loadMap(options);
						}
					},
					sync: scope.sync
				});

			if ($.screen.size() > 1) {
				$.events.on('.preview a', 'mousedown', (e, el) => {
					const cover = $('img', el)[0];

					if (cover && cover.src.includes('/small/')) {
						$.assets.load({
							img: cover.src.replace('/small/', '/large/')
						});
					}
				}, {
					delegate: '$propertiesMap, $propertiesRight',
					namespace: 'properties'
				});
			}

			$.events.on('$saveSearch', 'click', () => {
				LS.util.load('save', () => {
					Apt.save.init();
				}, true, false);
			}, {
				delegate: '$propertiesRight',
				namespace: 'properties'
			});

			$results[0].dataset.value = '';
		});

		if (scope.sync) {
			scope.sync.$private.conf.index = scope.index;
		}
	},

	/**
	 * Load promoted agent for location
	 *
	 * @param {Object} loc
	 * @param {Object} [result]
	 */
	loadAgent(loc, result) {
		const $agent = $$('propertiesAgent');

		if (result && (
			! loc ||
			loc.type === 'country' ||
			loc.type === 'territory'
		)) {
			loc = result.location.subterritory;
		}

		if (! loc) {
			$agent.empty();

			return;
		}

		LS.util.scrolled($agent, 'properties', () => {
			LS.profiles.feature($agent, LS.util.sanitize({
				location: loc.slug,
				price: (LS.filters.get('price') || {}).max,
				size: (LS.filters.get('size') || {}).max,
				specialties: LS.filters.get('type')
			}));
		}, {
			margin: 920
		});
	},

	/**
	 * Update the properties view
	 *
	 * @param {Object} data
	 */
	updateApp(data) {
		const scope = this;

		scope.sources = {};

		if (data.title) {
			const context = $.get('context');

			context.location = data.location;

			delete context.targeting;

			document.title = data.title + ' - LandSearch';

			$$('propertiesTitle').text(data.heading);

			$('.js-context').data('value', context);

			if (scope.map && LS.filters.get('location')) {
				scope.map.position();
			}
		}

		if (scope.map) {
			scope.clearMap(scope.map, true);
		}

		scope.updateSources(data);
	},

	/**
	 * Update the properties analytics
	 *
	 * @param {Object} data
	 */
	updateTracking(data) {
		if (! data || ! data.length) {
			return;
		}

		Object.values(data).forEach(item => {
			LS.analytics.track({
				action: 'preview',
				target: 'listing',
				id: item.id,
				category: 'entry',
				segment: 'results'
			}, {
				key: item.context.key,
				source: item.context.source,
				send: false
			});
		});

		LS.analytics.send();
	},

	/**
	 * Update sources
	 *
	 * @param {Object} data
	 */
	updateSources(data) {
		const scope = this;
		const $sources = $$('propertiesSources');

		if (! data.sources) {
			if (! Object.keys(scope.sources).length) {
				$sources.empty();
			}

			return;
		}

		data.sources.forEach(source => {
			scope.sources[source.id] = source;
		});

		$sources.html(
			$.view.render('properties._sources', {
				sources: scope.sources
			})
		);
	},

	/**
	 * Display fallback results
	 *
	 * @param {Array} exclude
	 */
	fallbackApp(exclude) {
		const scope = this;
		const params = LS.filters.get();
		const $element = $($.view.render('properties.fallback', {
			empty: ! exclude.length,
			location: $.context('location.heading')
		}));

		if (! params.location) {
			return;
		}

		delete params.location;

		params.exclude = exclude;
		params.limit = 48;

		params.attach = [
			'sources'
		];

		$$('results').append($element);

		scope.fallback = Apt.fn['properties.relevant']().init({
			params: params,
			map: () => scope.map,
			resource: 'listings',
			standalone: false,
			createMap: options => {
				if (! scope.map) {
					scope.loadMap(options);
				}

				return scope.map;
			},
			updated: data => {
				if (! data.results.length) {
					$$('propertiesFallback').hide();

					return;
				}

				$element.show();

				scope.updateSources(data);
			},
			unload: () => {
				scope.fallback = null;
			}
		}, {
			position: [2, 12, 20, 30, 38, 48],
			target: () => scope.getTarget()
		});
	},

	/**
	 * Refresh properties view
	 */
	refresh() {
		const scope = this;
		const filters = LS.filters.get();

		if (scope.sync) {
			if (filters.location) {
				scope.sync.disable(false);
			} else if (scope.sync.check(true)) {
				scope.sync.$private.refresh();
			}
		}

		if (scope.map) {
			if (! filters.geometry) {
				scope.map.removeDraw();
			}

			scope.map.update();
		}

		scope.index.update({
			event: false
		}, filters);
	}
});